// extracted by mini-css-extract-plugin
export var errorIcon = "_my-1";
export var nameLogo = "_my-0";